import { FC } from 'react';
import { Tabs, Typography } from 'antd';
import { Tags } from 'lucide-react';
import { TbCrosshair, TbTools } from 'react-icons/tb';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

import Metadata from './meta';
import Overview from './views/01-Overview';
import PrimitiveManager from './views/02-Primitives';

const Preferences: FC = (): JSX.Element => {
    const { token } = useAntDesignTheme();
    const location = useLocation();
    const navigate = useNavigate();
    const url = '/settings/account/preferences';
    const items = [
        {
            children: <Overview />,
            key: 'overview',
            label: (
                <>
                    <TbTools size='1rem' style={{ marginRight: '0.375rem', verticalAlign: '-0.175rem' }} />
                    Overview
                </>
            ),
        },
        {
            children: <PrimitiveManager kind='tags' />,
            key: 'tags',
            label: (
                <>
                    <Tags size='1rem' style={{ marginRight: '0.375rem', verticalAlign: '-0.175rem' }} />
                    Tags
                </>
            ),
        },
        {
            children: <PrimitiveManager kind='watchlists' />,
            key: 'watchlists',
            label: (
                <>
                    <TbCrosshair size='1rem' style={{ marginRight: '0.375rem', verticalAlign: '-0.175rem' }} />
                    Watchlists
                </>
            ),
        },
    ];
    const routeKey = location.pathname.split('/')[4];
    const activeKey = items.some((item) => item.key === routeKey) ? routeKey : 'overview';

    return (
        <>
            <Metadata />
            <Typography.Title id='preferences' level={1}>
                Preferences
            </Typography.Title>
            <Typography.Paragraph style={{ color: token.colorTextTertiary }}>
                Manage your experience, reusable tags, and company watchlists.
            </Typography.Paragraph>
            <Routes>
                <Route index element={<Navigate replace to={`${url}/overview`} />} />
                <Route
                    path='*'
                    element={
                        <Tabs
                            activeKey={activeKey}
                            animated
                            items={items}
                            size='small'
                            onChange={(key) => navigate(`${url}/${key}`)}
                        />
                    }
                />
            </Routes>
        </>
    );
};

export default Preferences;
